import React, {Fragment} from "react";
import ModalConfirm from "../../../components/ModalConfirm";
import ModalMsg from "../../../components/ModalMsg";
import Sidebar from "../../../components/Sidebar";
import NsAccordion from "../../../components/accordion/NsAccordion";
import NsDataTable from "../../../components/tabelle/NsDataTable";
import ModalUploadElementi from "../../../components/ModalUploadElementi";

export default function ConfMacrocategorieView({
                                                   showConfirm,
                                                   setShowConfirm,
                                                   eliminaMacrocategoria,
                                                   macrocategoriaSel,
                                                   translate,
                                                   show,
                                                   setShow,
                                                   modalMsg,
                                                   isMobile,
                                                   loadingData,
                                                   getAlberoStruttura,
                                                   macrocategorie,
                                                   showModalUploadMacr,
                                                   setShowModalUploadMacr,
                                                   updateDati,
                                                   token
                                               }) {

    return (
        <Fragment>
            <ModalConfirm
                show={showConfirm}
                handleClose={() => setShowConfirm(false)}
                handleOk={eliminaMacrocategoria}
                testo={translate("Sicuro di voler eliminare la struttura KPI: ") + (macrocategoriaSel && (macrocategoriaSel.descrizione)) + "?"}/>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <ModalUploadElementi
                titolo={"Upload Macrocategorie"}
                endopoint={process.env.REACT_APP_API_ENDPOINT + `/api/sost/macrocategorie/template-import/`}
                show={showModalUploadMacr}
                translate={translate}
                token={token}
                handleClose={() => {
                    setShowModalUploadMacr(false);
                    updateDati();
                }}/>
            {
                !loadingData &&
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura macrocategorie'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <NsDataTable
                            data={macrocategorie}
                            columns={[
                                {
                                    name: translate('Codice'),
                                    selector: row => row.codice,
                                    sortable: true
                                },
                                {
                                    name: translate('Descrizione'),
                                    selector: row => row.descrizione,
                                    sortable: true
                                },
                                {
                                    name: translate('Classe'),
                                    selector: row => row.classe_macrocategoria,
                                    sortable: true
                                },
                            ]}
                            addFiltri={false}
                        >
                        </NsDataTable>
                    </Sidebar>
                </Fragment>
            }
        </Fragment>
    );
}
